import React, {memo} from 'react';
import classNames from "classnames";
import PropTypes from 'prop-types';
import {formatUtcDateIntoTimezone} from "../../../utils/DateTime";

const StartDateColumn = memo(({template, projectState}) => {
  return (
    <td>
      <p className={classNames({
        'text-center': true,
        'text-gray': !template.status,
      })}>{formatUtcDateIntoTimezone(template.start_date, "yyyy-MM-dd HH:mm", projectState.timezone)}</p>
    </td>
  );
});

StartDateColumn.propTypes = {
  template: PropTypes.object.isRequired,
};

export default StartDateColumn;
